export enum OrderProgrammingHourType {
  INDICATE_DAY,
  FIRST_PROGRAMMED_SERVICE,
  PLUS_48_HOURS,
  PLUS_72_HOURS,
}
